import React from "react"
import styled from "styled-components"
import Button from "../button/button"

const Wrapper = styled.div`
  width: 100%;
  height: 25rem;
  position: relative;
  @media screen and (min-width: 768px) {
  }
`

const VideoStyled = styled.iframe`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

const VideoContentStyled = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 6;
  h2,
  p {
    font-size: 16px;
  }
  > * {
    padding: 0;
    margin: 0 0 0.7rem;
  }
  > *:last-child {
    margin-bottom: 0;
  }

  div > button:first-of-type {
    margin-right: 0.5rem;
  }
`

const Video = ({ tagline, coolQuote, src }) => {
  return (
    <Wrapper>
      <VideoStyled src={src} frameBorder="0">
        <VideoContentStyled>
          <h2>{tagline}</h2>
          <p>{coolQuote}</p>
          <div>
            <Button>Watch</Button>
            <Button isSecondary>Shop</Button>
          </div>
        </VideoContentStyled>
      </VideoStyled>
    </Wrapper>
  )
}

export default Video
